import { action, ActionType } from 'typesafe-actions';
import { RESET_STATE } from './constants';

export type RootActions = ActionType<typeof resetApplicationState>;

export const resetApplicationState = () => action(RESET_STATE);
